module.exports = __webpack_public_path__ + "static/media/ACS Dovetail.e9b56c34.csv";